import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=ddbe396c&"
import script from "./WidgetContainer.vue?vue&type=script&lang=js&"
export * from "./WidgetContainer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContainer.vue?vue&type=style&index=0&id=ddbe396c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports